import themeGet from '@styled-system/theme-get';
import { createGlobalStyle } from 'styled-components/macro';
import reset from 'styled-reset';
import AllProviders from 'utils/providers';

import { configInterceptors } from './helpers/http-client';
import Routes from './routes';

configInterceptors();

export const GlobalStyle = createGlobalStyle`
  ${reset}

  *::before,
  *::after {
    box-sizing: inherit;
  }

  body {
    font-family: ${themeGet('font')};
    line-height: 1.5;
  }

  b { font-weight: bold; }

  button { font-family: ${themeGet('font')}; }
`;

const App = () => {
  return (
    <AllProviders>
      <Routes />
    </AllProviders>
  );
};

export default App;
